import React from "react"
import PropTypes from "prop-types"
import { ThemeProvider } from "styled-components"

import Header from "./Header"
import Footer from "./footerLayout"
import GlobalStyle from "../../layout/globalStyles"
import { baseTheme } from "../../css/theme"
import { Content } from "./Content"

import styled from "styled-components"

const Layout = ({ headerData, footerData, children, location }) => {
  return (
    <ThemeProvider theme={baseTheme}>
      <GlobalStyle />
      <Wrapper>
        <Header data={headerData} location={location} />
        <Content>{children}</Content>
        {location && location.pathname !== '/calendar' ? <Footer data={footerData}/> : ''}
      </Wrapper>
    </ThemeProvider>
  )
}

Layout.propTypes = {
  children: PropTypes.node.isRequired,
  headerData: PropTypes.object.isRequired,
  footerData: PropTypes.object.isRequired,
}

const Wrapper = styled.main`
  display: flex;
  flex-direction: column;
`

export default Layout
